import React, { useState } from "react";
import { getZetsuboFile } from "../../utils/theme";

type PropType = {
	image: string;
	chooseTheme: (id:string) => void;
};

const ZetsuboCard = (props: PropType) => {
	const { image, chooseTheme } = props;
	const [isChecked, setIsChecked] = useState<boolean>(false);
	const itemPath = getZetsuboFile(image);
    const onChange = (event: React.ChangeEvent<HTMLInputElement>): void  => {
        chooseTheme(event.target.id);
        setIsChecked(!isChecked);
    }
	return (
		<div className="m-1  min-w-[80px]">
			<input className="hidden" type="checkbox" onChange={onChange} checked={isChecked} id={image} />
			<label htmlFor={image}>
				<img
					src={itemPath}
					alt={image}
					className="box-border"
				/>
			</label>
		</div>
	);
};

export default ZetsuboCard;
